// extracted by mini-css-extract-plugin
export default {"projectViewContainer":"ProjectViews_projectViewContainer__LBKXc","customDomainSection":"ProjectViews_customDomainSection__0YF1x"};